import { ethylene, MediumTypesEnum, propylene } from 'src/modules/user-input/calcV100/constants.ts';

export const getConcentrations = (medium: MediumTypesEnum) => {
    if (medium === MediumTypesEnum.Propylene) {
        return Object.keys(propylene.density);
    }
    if (medium === MediumTypesEnum.Ethylene) {
        return Object.keys(ethylene.density);
    }
    return [];
};
